import { AssignMembersToJobsDialogComponent } from '@core/tellent-assign-members-to-jobs-smart-ui';
import { UserInvitationStep, UserInvitationStepI } from '@core/tellent-types';
import { DialogWidth } from '@core/user-interface-legacy';

import { AddEmployeeForPreonboardingDialogComponent } from '../add-employee-for-preonboarding-dialog/add-employee-for-preonboarding-dialog.component';
import { AddEmployeeWithoutAccessDialogComponent } from '../add-employee-without-access-dialog/add-employee-without-access-dialog.component';
import { AddMemberDialogComponent } from '../add-member-dialog/add-member-dialog.component';
import { AddMemberDialogNewComponent } from '../add-member-dialog-new/add-member-dialog-new.component';
import { DownloadCredentialsDialogComponent } from '../download-credentials-dialog/download-credentials-dialog.component';
import { JourneysPromoDialogComponent } from '../journeys-promo-dialog/journeys-promo-dialog.component';
import { MemberAddedSuccessDialogComponent } from '../member-added-success-dialog/member-added-success-dialog.component';
import { SubdomainInformationDialogComponent } from '../subdomain-information-dialog/subdomain-information-dialog.component';

export const stepComponentMap: Record<UserInvitationStep, UserInvitationStepI> = {
  add_member: {
    dialogComponent: AddMemberDialogComponent,
    dialogConfig: { width: DialogWidth.Small },
  },
  add_member_new: {
    dialogComponent: AddMemberDialogNewComponent,
    dialogConfig: { width: DialogWidth.Small },
  },
  add_employee_for_preonboarding: {
    dialogComponent: AddEmployeeForPreonboardingDialogComponent,
    dialogConfig: { width: DialogWidth.Small },
  },
  add_employee_without_access: {
    dialogComponent: AddEmployeeWithoutAccessDialogComponent,
    dialogConfig: { width: DialogWidth.Large },
  },
  assign_members_to_jobs: {
    dialogComponent: AssignMembersToJobsDialogComponent,
    dialogConfig: { width: DialogWidth.Small },
  },
  member_added_success: {
    dialogComponent: MemberAddedSuccessDialogComponent,
    dialogConfig: { width: DialogWidth.SmallX },
  },
  download_credentials: {
    dialogComponent: DownloadCredentialsDialogComponent,
    dialogConfig: { width: DialogWidth.Small },
  },
  subdomain_information: {
    dialogComponent: SubdomainInformationDialogComponent,
    dialogConfig: { width: DialogWidth.Small },
  },
  journey_promo_dialog: {
    dialogComponent: JourneysPromoDialogComponent,
    dialogConfig: { width: DialogWidth.Large },
  },
};
